// components
import { Form } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Label from "components/atoms/Label/Label";
import { InputValueType } from "containers/SpecialApprovalRetrospectiveClaim/useSpecialApprovalRetroClaim";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";

// styles
import styles from "components/molecules/RequestClaimDetails/requestClaimDetails.module.css";

// Constants
import { SPECIAL_APPROVAL_RETRO_CLAIM as Constants } from "constants/global";

// redux
import { RetroClaimType } from "redux/types";

export type RequestClaimDetailsProps = {
	retroClaimDetails?: RetroClaimType;
	inputValue?: InputValueType;
	isReasonValid: boolean;
	handleInput: (value: string) => void;
	validateReason?: (value: string) => void;
};

type ErrorMessageWrapperTypes = {
	fieldError?: boolean;
	message: string;
};

const ErrorMessageWrapper = ({ fieldError, message }: ErrorMessageWrapperTypes) => {
	return fieldError ? <ErrorMessage classes={styles?.err_message} message={message} /> : <></>;
};

const RequestClaimDetails = ({ validateReason, isReasonValid, retroClaimDetails, inputValue, handleInput }: RequestClaimDetailsProps) => {
	const textCls = inputValue?.input && isReasonValid ? styles?.basic_input_active : styles?.err;

	return (
		<Form className={styles?.form} requiredMark={false} layout="vertical">
			<div className="md:flex">
				{retroClaimDetails?.status && (
					<Form.Item name="status" label={<Label label={Constants.STATUS_LABEL} classes={{ label: styles?.basic_input_label }} />}>
						<p className={`${styles?.basic_text_purple}`}>{retroClaimDetails?.status?.replace("_", " ")}</p>
					</Form.Item>
				)}

				<Form.Item name="source" label={<Label label={Constants.SOURCE_LABEL} classes={{ label: styles?.basic_input_label }} />}>
					<p className={`${styles?.basic_text}`}>{retroClaimDetails?.source}</p>
				</Form.Item>
			</div>
			<div className={styles?.textArea_wrapper}>
				<Form.Item
					name={Constants.REASON_FOR_APPROVAL}
					extra={<ErrorMessageWrapper message={Constants.INVALID_REJECTION_ERR} fieldError={!!inputValue?.input && !isReasonValid} />}
					label={<Label classes={{ label: styles?.basic_input_label }} label={Constants.REASON_FOR_APPROVAL} />}
				>
					<TextArea
						value={inputValue?.input}
						className={!inputValue?.input ? styles?.basic_input : textCls}
						data-testid="approval_reason"
						rows={9}
						onChange={(e) => handleInput(e.target?.value)}
						onBlur={(e) => validateReason?.(e.target?.value)}
					/>
				</Form.Item>
			</div>
		</Form>
	);
};

export default RequestClaimDetails;
